<template>
  <div class="app-container">
    <el-row :gutter="10">
      <el-col :lg="3">
        <el-input v-model="listQuery.fieldName" placeholder="请输入场地名称"/>
      </el-col>
      <el-col :lg="3">
        <el-date-picker
          v-model="listQuery.startTime"
          :clearable="false"
          class="custom-width"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"/>
      </el-col>
      <el-col :lg="3">
        <el-date-picker
          v-model="listQuery.endTime"
          :clearable="false"
          class="custom-width"
          value-format="yyyy-MM-dd"

          type="date"
          placeholder="选择结束日期"/>
      </el-col>
      <el-col :lg="2">
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
      <el-col :lg="2">
        <el-button type="primary" @click="handleDown">导出</el-button>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      stripe
      highlight-current-row
      style="width: 100%;margin-top: 20px;"
    >
      <el-table-column label="场地名称" align="center">
        <template slot-scope="{row}">
          <span>{{ row.FieldName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`已结束订单总数`" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.TotalEndOrder }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`使用中的订单`" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.TotalProcessOrder }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`收入（元）`" align="center">
        <template slot-scope="{row}">
          <!-- <span>{{ (row.TotalEndOrder+row.TotalProcessOrder)*row.Deposit }}</span> -->
          <span>{{ row.TotalPayOrder }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`退还押金（元）`" align="center">
        <template slot-scope="{row}">
          <span>{{ row.TotalReturnDeposit }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`剩余押金（元）`" align="center">
        <template slot-scope="{row}">
          <span>{{ row.TotalRemainDeposit }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`场地分成比例`" align="center">
        <template slot-scope="{row}">
          <span>{{ row.FieldProportion }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`收益（元）`" align="center">
        <template slot-scope="{row}">
          <span>{{ row.TotalFieldIncome }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`金额总计（元）`" align="center">
        <template slot-scope="{row}">
          <span>{{ row.TotalAmount }}</span>
        </template>
      </el-table-column>

    </el-table>
    <div class="pagination-container">
      <el-pagination
        v-show="total>0"
        :current-page="listQuery.pageIndex"
        :page-sizes="[10,20,50,100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { qryFieldInfoIncome, exportFieldIncomeExcel } from '@/api/report'
import moment from 'moment'
export default {
  // 组件名称
  name: 'Report',
  // 过滤器
  filters: {
  },
  // 组件
  components: {
  },
  // props类型
  props: {
  },
  // 数据
  data() {
    return {
      listLoading: true,
      listQuery: {
        fieldName: null,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        pageIndex: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      url_: process.env.BASE_API
    }
  },
  // 计算属性
  computed: {
  },
  // 计算属性监听
  watch: {
    'listQuery.fieldName'(value) {
      if (!value) {
        this.listQuery.fieldName = null
      }
    }
  },
  // 创建时
  created() {
    this.getList()
  },
  // 挂载完毕
  mounted() {
  },
  // 方法
  methods: {
    getList() {
      this.listLoading = true
      qryFieldInfoIncome(this.listQuery).then(res => {
        if (res) {
          this.list = res.LsList
          this.total = res.TotalRows
        }
        this.listLoading = false
      })
    },
    // 搜索
    search() {
      this.getList()
    },
    // 导出
    handleDown() {
      const { fieldName, startTime, endTime } = this.listQuery
      exportFieldIncomeExcel({ fieldName, startTime, endTime }).then(res => {
        if (res) {
          window.open(this.url_ + res)
          this.getList()
        }
      })
    },
    // 修改页容量重新查询列表
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 修改页码重新查询列表
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    }
  }
}
</script>

<style lang='less' scoped>
.custom-width{
  width: 100%;
}
</style>

